module.exports = __webpack_public_path__ + "static/media/55783929_2519322668142909_6192077710970322944_o.b3e54d14.jpg";